<template>
    <div class="notice-manage-container">
      <div class="manage-header">
        <el-button type="primary" @click="goToWrite">공지사항 추가</el-button>
      </div>

    <AgGridVue
      class="ag-theme-alpine"
      style="width: 100%; height: 600px"
      :columnDefs="columns"
      :rowData="notices"
      :gridOptions="gridOptions"
      @grid-ready="onGridReady"


    />
    <NoticeDetailDialog
      v-if="showDetail"
      :notice="selectedNotice"
      @close="showDetail = false"
      @updated="onGridReady"
    />

  </div>

  </template>
  
  <script setup>
  import { ref } from 'vue'
  import { AgGridVue } from 'ag-grid-vue3'
  import axiosInstance from "@/api/axios"; // Axios 인스턴스 가져오기
  import { useRouter } from "vue-router";
  import NoticeDetailDialog from '@/components/NoticeDetailDialog.vue'  // ✅ 실제 경로에 맞게

  const notices = ref([])
  const router = useRouter()
  const selectedNotice = ref(null)
  const showDetail = ref(false)

  const columns = [
    { headerName: 'ID', field: 'id'},
    { headerName: '제목', field: 'title', sortable: true },
    { headerName: '작성자', field: 'created_by_name' },
    {
      headerName: '시작일',
      field: 'start_date',
      valueFormatter: (params) => formatDateKorean(params.value)
    },
    {
      headerName: '종료일',
      field: 'end_date',
      valueFormatter: (params) => formatDateKorean(params.value)
    },
 
  ]


  const gridOptions = {
    columnDefs: columns,
    rowSelection: {
      type: 'multiple',
      checkboxes: true
    },
    onRowDoubleClicked: (params) => {
      selectedNotice.value = params.data
      showDetail.value = true
      //router.push(`/notices/${params.data.id}`)
    }
  }
  
  const onGridReady = async () => {
    const res = await axiosInstance.get('/notices/')
    notices.value = Array.isArray(res.data.results) ? res.data.results : []
  }

  const goToWrite = () => {
    router.push('/notices/write')
  }

  const formatDateKorean = (value) => {
    const date = new Date(value)
    return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일`
  }

  </script>

<style scoped>
.manage-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>